import React from "react";
import { Form, Formik, Field } from "formik";
import { ApiService } from "../../../../../services/ApiService";

export default function CreateJobtitle({
  closeModal,
  alert,
  offices,
  getJobtitle,
}) {
  return (
    <React.Fragment>
      <div className="">
        <h4 className="modal-title w-100" style={{ color: "#000" }}>
          Create Job title
        </h4>
        <hr />
      </div>
      <Formik
        initialValues={{ job_title: "", office_id: "" }}
        onSubmit={(values) => {
          ApiService.post("job-titles/create-job-title", values).then((res) => {
            if (res.data.type === false) {
              alert.error(res.data.msg);
            } else if (res.data.type === true) {
              alert.success(res.data.msg);
            }
            getJobtitle();
            closeModal();
          });
        }}
      >
        {({ handleSubmit, values, isSubmitting, handleChange }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    Name <span className="text-danger"> * </span> 
                  </label>
                  <Field
                    type="text"
                    className="form-control"
                    name="job_title"
                    required
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    Office Type <span className="text-danger"> * </span>
                  </label>
                  <select
                    name="office_id"
                    type="text"
                    onChange={handleChange}
                    className="form-control"
                    required
                  >
                    <option value="">--Select office--</option>
                    {offices.map((office, i) => (
                      <option value={office.id} key={i}>
                        {office.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/systemconfiguration/jobtitle/modal/create_jobtitle.js